import { render, staticRenderFns } from "./DuplicateIncidents.vue?vue&type=template&id=2e83fc17&"
import script from "./DuplicateIncidents.vue?vue&type=script&lang=js&"
export * from "./DuplicateIncidents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports